import { CreateElement } from 'vue'
import { RouteConfig } from 'vue-router'
import { CreateRouterOptions } from '@/typings/common'
import { LK_PUBLICATIONS_FORMDATA_ROUTES as ROUTES } from './utils'
import { registerModule } from './store'


type Options = Required<CreateRouterOptions>
type PromiseVue = Promise<typeof import('*.vue')>

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const createRoutes = (options: Options): RouteConfig[] => [
  {
    path: ':topic_slug/:slug?/formdata',
    name: ROUTES.LAYOUT,
    meta: { authorized: true },
    component: {
      name: 'ViewLKPublicationsFormdataLayout',
      render: (h: CreateElement) => h('router-view'),
    },
    children: [
      {
        path: ':form_data_id?/data-collection/:data_collection_id/form-template/:form_template_id',
        name: ROUTES.FORM,
        props: true,
        async beforeEnter(to, from, next) {
          const { registerModule: handbookRegisterModule } = await import(
            /* webpackChunkName: "form-handbook.store" */
            '@/views/FormsHandbook/store/cache'
          )
          handbookRegisterModule(options)
          next()
        },
        component: (): PromiseVue => import(
          /* webpackChunkName: "lk-publications.formdata.form" */
          './LKPublicationsFormdataView.vue'
        ),
      },
    ],
  },
]

const createModule = (options: Options) => {
  const routes = createRoutes(options)
  registerModule(options)
  return routes
}

export default createModule
